import gql from 'graphql-tag';

export const GET_METRICS_BY_METRO = gql`
  query getMetricsByMetro($params: ReportInput!) {
    metricsByMetro(params: $params) {
      transactionMetricsByMetro {
        city
        state
        numberOfTransactions
        avgAov
        latitude
        longitude
      }

      topMetrosByTransactionCount {
        city
        state
        numberOfTransactions
      }

      topMetrosByAov {
        city
        state
        avgAov
      }

      topMetrosByRevenue {
        city
        state
        totalRevenue
      }
    }
  }
`;

export const GET_TOP_VENUES_BY_INDICATOR = gql`
  fragment topVenue on TopVenue {
    address
    city
    state
  }

  query getTopVenuesByIndicator($params: ReportInput!) {
    topVenuesByIndicator(params: $params) {
      sales {
        ...topVenue
        totalRevenue
      }

      transactions {
        ...topVenue
        numberOfTransactions
      }

      aov {
        ...topVenue
        avgAov
      }
    }
  }
`;

export default GET_METRICS_BY_METRO;
